import * as z from 'zod'
import { dateSchema, uuidOptionSchema } from '~/shared/lib/schemas'

import { ApiModel, ToOneRelation } from './core'
import { Story } from './story'

const attributeSchema = z.object({
  title: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  content: z.string().optional().nullable(),
  sort: z.string().transform(Number),
  externalLink: z.string().optional().nullable(),
  image: z.object({
    url: z.string(),
    uuid: z.string(),
  }),
})

const relationsSchema = z.object({
  storyId: uuidOptionSchema,
})

const schema = z
  .object({
    createdAt: dateSchema.optional(),
    updatedAt: dateSchema.optional(),
  })
  .merge(attributeSchema)
  .merge(relationsSchema)

export type PostAttributes = z.infer<typeof schema>

export class Post extends ApiModel<typeof schema> {
  static jsonApiType = 'posts'

  static schema = schema

  getTitle(): string {
    return this.getAttribute('title')
  }
  getDescription(): string {
    return this.getAttribute('description')
  }
  getContent(): string {
    return this.getAttribute('content')
  }
  getSort(): string {
    return this.getAttribute('sort')
  }
  getImage(): string {
    const image = this.getAttribute('image')
    return image?.url
  }
  getExternalLink(): string {
    return this.getAttribute('externalLink')
  }

  story(): ToOneRelation<Story, this> {
    return this.hasOne(Story)
  }
  getStory(): Story {
    return this.getRelation('story')
  }
  setStory(id: UniqueId) {
    const story = new Story()
    story.setApiId(id)
    this.setRelation('story', story)
  }
}
